import { appleLogin } from './appleLogin.js';
import { twoStepModal } from './twoStepModal.js';
// Import and spread all experiments from the currentExperiments file
export const allExperiments = {
    ...twoStepModal,
    ...appleLogin,
};
//# sourceMappingURL=index.js.map